<template>
  <div>
    <div class="page page__has-bar">
      <div class="page__bd" v-if="!showPersonnelModal && !showMeetingRoomModal">
        <div class="weui-cells">
          <div class="weui-cell" slot="me_title">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.me_title || "会议议题"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                v-model="form.main.me_title"
                placeholder="请填写"
              />
            </div>
          </div>
          <div
            class="weui-cell weui-cell_select weui-cell_select-after"
            slot="me_remind"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.me_remind || "提醒设置"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <select
                class="weui-select"
                v-model="form.main.me_remind"
                placeholder="请选择"
              >
                <option value="0">会议开始前</option>
                <option value="5">5分钟前</option>
                <option value="15">15分钟前</option>
                <option value="30">30分钟前</option>
                <option value="60">1小时前</option>
                <option value="1440">1天前</option>
              </select>
            </div>
          </div>
          <date-field
            slot="me_date"
            :label="customLabel.me_date || '会议日期'"
            v-model="form.main.me_date"
            @change="getPersonnelStaus"
          />
          <time-field
            slot="me_start"
            :label="customLabel.me_start || '开始时间'"
            v-model="form.main.me_start"
            @change="getPersonnelStaus"
          />
          <time-field
            slot="me_over"
            :label="customLabel.me_over || '结束时间'"
            v-model="form.main.me_over"
            @change="getPersonnelStaus"
          />
          <account-check-box
            :label="'参会人员'"
            slot="me_emnames"
            v-model="form.main.me_emnames"
            @select="onSelectCcrecipients"
          />
          <div class="weui-cell" v-if="list.length > 0">
            <div class="weui-cell__hd">
              <label for class="weui-label">查看闲忙</label>
            </div>
            <div class="weui-cell__bd">
              <div class="list-status">
                <div
                  class="list-item"
                  v-for="(item, index) in list"
                  :key="index"
                >
                  <span class="list-item-text">{{ item.emname }}</span>
                  <span v-if="item.status" class="list-item-status mang"
                    >忙</span
                  >
                  <span v-else class="list-item-status xian">闲</span>
                </div>
                <span class="iconfont icon-more" @click="open()"></span>
              </div>
            </div>
          </div>
          <meeting-field
            slot="me_mrname"
            :label="customLabel.me_mrname || '会议室'"
            v-model="form.main.me_mrname"
            @select="onSelectMeeting"
          />
          <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label">查看会议室</label>
            </div>
            <div class="weui-cell__bd">
              <div class="list-status">
                <span class="iconfont icon-more" @click="lookRoom()"></span>
              </div>
            </div>
          </div>
          <div class="weui-cell" slot="me_address">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.me_address || "地点"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <p>{{ form.main.me_address }}</p>
            </div>
          </div>
          <div class="weui-cell" slot="me_content">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.me_content || "会议纪要"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                :placeholder="customLabel.me_content || '会议纪要'"
                rows="3"
                v-model="form.main.me_content"
              ></textarea>
              
              <!-- <div class="weui-textarea-counter">
                <span>{{
                  form.main.me_content ? form.main.me_content.length : 0
                }}</span
                >字
              </div> -->
            </div>
          </div>
          
        </div>

        <div class="weui-cells__group">
          <div class="weui-cells__title">附件</div>
          <div class="weui-cells">
            <file-field v-model="form.main.me_attach" />
          </div>
        </div>
      </div>

      <div
        class="footer-bar weui-dialog__ft"
        v-if="!showPersonnelModal && !showMeetingRoomModal"
      >
        <a
          href="javascript:;"
          class="weui-dialog__btn weui-dialog__btn_primary"
          @click="save"
          >提交</a
        >
        <a
          href="javascript:;"
          class="weui-dialog__btn weui-dialog__btn_default"
          @click="$router.back()"
          >取消</a
        >
      </div>
    </div>
    <div style="height: 600px">
      <personnel-table
        v-if="showPersonnelModal"
        :params="form"
        @close="closePersonnelModal"
      ></personnel-table>
      <meeting-room
        v-if="showMeetingRoomModal"
        :params="form"
        @close="closeMeetingRoomModal"
      ></meeting-room>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/field/DateField.vue";
import TimeField from "@/components/field/TimeField.vue";
import AccountCheckBox from "@/components/field/AccountCheckBox.vue";
import MeetingField from "@/components/field/MeetingField.vue";
import FileField from "@/components/field/FileField.vue";
import PersonnelTable from "./PersonnelTable.vue";
import MeetingRoom from "./MeetingRoom.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    DateField,
    AccountCheckBox,
    MeetingField,
    PersonnelTable,
    MeetingRoom,
    FileField,
    TimeField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/oa/meeting",
      codeField: "me_code",
      caller: "Meeting",
      xtype: "oa-meeting-formpanel",
      showPersonnelModal: false,
      showMeetingRoomModal: false,
      form: {
        main: {
          id: 0,
          me_emnames: null,
          me_emids: null,
          me_date: null,
          me_address: null,
          me_mrname: null,
          me_remind: "5",
          me_title: null,
          me_content: null,
          me_start: null,
          me_over: null,
        },
      },
      list: [],
    };
  },
  watch: {
    "form.main.id"(val) {
      var me = this;
      if (val) {
        me.$nextTick(function () {
          me.getPersonnelStaus();
        });
      }
    },
    "form.main.me_date"(val) {
      var me = this;
      if (val) {
        me.$nextTick(function () {
          me.getPersonnelStaus();
        });
      }
    },
    "form.main.me_start"(val) {
      var me = this;
      if (val) {
        me.$nextTick(function () {
          me.getPersonnelStaus();
        });
      }
    },
    "form.main.me_over"(val) {
      var me = this;
      if (val) {
        me.$nextTick(function () {
          me.getPersonnelStaus();
        });
      }
    },
  },
  methods: {
    closePersonnelModal() {
      this.showPersonnelModal = false;
    },
    closeMeetingRoomModal() {
      this.showMeetingRoomModal = false;
    },
    getPersonnelStaus() {
      var me = this,
        main = me.form.main;
      if(!main.me_emids){
        return
      }
      me.$loading({
        url: "/api/oa/meeting/getEmStatus",
        params: {
          meid: main.id,
          emids: main.me_emids,
          date: me.dateFormat(new Date(main.me_date), "yyyy-MM-dd"),
          start: main.me_start,
          over: main.me_over,
        },
      }).then(function (res) {
        if (res.success) {
          me.list = res.data ? res.data : [];
        } else {
          me.$weui.topTips(res.message, 2000);
        }
      });
    },
    open() {
      let me = this;
      me.showPersonnelModal = true;
    },
    lookRoom() {
      let me = this,form = me.form;
      if(!form.main.me_date){
        me.$weui.topTips("请选择会议日期", 2000);
        return
      }
      me.showMeetingRoomModal = true;
    },
    onSelectCcrecipients(selection) {
      let main = this.form.main;
      (main.me_emnames = selection.map((item) => item.em_name).join(",")),
        (main.me_emids = selection.map((item) => item.id).join(","));
      this.getPersonnelStaus();
    },
    onSelectMeeting(item) {
      let main = this.form.main;
      main.me_mrname = item.mr_name;
      main.me_address = item.mr_address;
    },
    save() {
      var me = this,
        main = me.form.main;
      if (!main.me_title) {
        me.$weui.topTips("请输入会议议题", 2000);
      } else if (!main.me_mrname) {
        me.$weui.topTips("请选择会议室", 2000);
      } else if (!main.me_date) {
        me.$weui.topTips("请选择会议日期", 2000);
      } else if (!main.me_start) {
        me.$weui.topTips("请选择开始时间", 2000);
      } else if (!main.me_over) {
        me.$weui.topTips("请选择结束时间", 2000);
      } else if (!main.me_remind) {
        me.$weui.topTips("请选择提醒设置", 2000);
      } else {
        // 新增或编辑未提交的单据时先保存单据，再提交
        me.p_save();
      }
    },
    getRemind(value) {
      if (value == null) {
        return '不提醒'
      }
      switch (value) {
        case "0":
          return "会议开始前";
        case "5":
          return "5分钟前";
        case "15":
          return "15分钟前";
        case "30":
          return "30分钟前";
        case "60":
          return "1小时前";
        case "1440":
          return "1天前";
        default:
          return "不提醒";
      }
    }
  },
};
</script>

<style scoped>
.flex {
  display: flex;
}
.list-status {
  /* padding: 10px 10px; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
}
.list-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin: 5px 5px;
}
.list-item-status {
  display: inline-block;
  height: 20px;
  text-align: center;
  line-height: 20px;
  width: 20px;
  margin-left: 5px;
  padding: 0px;
}
.mang {
  color: #f48c3c;
  background-color: #fed3a0;
}
.xian {
  color: #348d3a;
  background-color: #cae4b4;
}
</style>